import { render, staticRenderFns } from "./HolidaysGroups.vue?vue&type=template&id=11cab5ec"
import script from "./HolidaysGroups.vue?vue&type=script&lang=js"
export * from "./HolidaysGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports